import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-unauthorised',
    templateUrl: './unauthorised.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnauthorisedComponent implements OnInit {
  roleId: number;
  constructor() { }

  ngOnInit() {
    this.roleId = Number(localStorage.getItem('roleId'));
    (document.querySelector('body') as HTMLElement).style.background = '#e6e9e9';
  }
}
